import { capacitySnapshots, kpiDailySnapshots } from '../snapshot'
import { describeTable } from './describeTable'

describeTable(capacitySnapshots, {
  description: `Nightly copy of the capacity heatmap: for each run (snapshot_date) one row per employee per calendar day over a window of 3 weeks back to 9 weeks forward, recording how booked that day looked at that moment. Written by the snapshotKpis Lambda; exists because reassignment hard-deletes visit_attendees rows and rescheduling rewrites them, so the past state cannot be recomputed from the booking tables.
Dense: zeros are stored, so an employee with no row in a run was not employed (or was a test account) on that run — read "no data", not zero. To compare "now vs a week ago" pick two snapshot_date runs and join on (user_id, day). Only the latest run for a given day is the truth for that day; earlier runs are what was expected then.
Starts only from when the cron was deployed (mid-August 2026); nothing exists before that. No soft delete. user_id is users.id.`,
  columns: {
    snapshotDate:
      'The run this row belongs to ("as of" date). One run per night, upserted if re-run.',
    capturedAt:
      'The instant the grid was actually read; differs from snapshot_date for rows backfilled from an older dump.',
    userId: 'users.id of the employee.',
    day: 'The calendar day the booking state describes.',
    totalMinutes:
      "Booked minutes on that day (sum of the person's visit slots) as of the run.",
    visitCount: 'Number of visits the person had on that day as of the run.',
    blocked:
      'True when the day had no bookings because of an absence or a blocking calendar event (holiday, meeting) — an unfillable day, not an empty one.',
  },
})

describeTable(kpiDailySnapshots, {
  description: `One row per night with scalar KPIs whose inputs mutate underneath them, so a past value can be read back rather than recomputed. Written by the same snapshotKpis Lambda as capacity_snapshots, from mid-August 2026 onward. A metric column added later is NULL for earlier runs — NULL means "not measured", never zero. Currently only the order backlog (tilauskanta) is stored.`,
  columns: {
    snapshotDate: 'The run date (unique).',
    capturedAt: 'The instant the values were read.',
    orderBacklogVisitCount:
      'Number of booked, undelivered future visits (tilauskanta) at capture time.',
    orderBacklogRevenue: 'Their net (VAT 0) value in euros at capture time.',
  },
})
